<template lang="pug">
  div(class="navigation-item" @click="select")
    div(class="navigation-item-inner")
      span {{ item.year }}
</template>

<script>
export default {
  name: 'navigation-item',
  props: ['item'],
  methods: {
    select () {
      this.$emit('selection', this.item)
    }
  }
}
</script>

<style lang="stylus">
.navigation-item
  position: relative
  width: 10em
  cursor: pointer;
  &:before
    content: ''
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    background: rgba(255, 255, 255, 0.65)
    transform: skewX(-18deg)
    opacity: 0
    transition: opacity 200ms ease
  &:hover
    &:before
      opacity: 0.4
  &-inner
    display: flex
    justify-content: center
    align-items: center
    height: 100%
    position: relative
    & span
      color: white
      font-size: 2em
      user-select: none
</style>



// WEBPACK FOOTER //
// src/components/navigation-item.vue